import ApiFiles from 'services/api_files';

export const createBiddingManagementDownloadAttachment = async (
  downloadLinksList: Array<number>,
) => {
  const response = await ApiFiles.post('/gerenciar_licitacoes/download_anexos', {
    downloadLinksList,
  });

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `gestao_${Date.now()}.zip`);
  document.body.appendChild(link);
  link.click();
};
